import React from 'react';
import { CreateActivityReportParams } from './extensions';

const LazyCreateActivityReport = React.lazy(() => import('./CreateActivityReport'));
export const AsyncCreateActivityReport: React.FC<CreateActivityReportParams> = param => {
	return (
		<React.Suspense fallback={<div data-test-id="create-activity-report" />}>
			<LazyCreateActivityReport {...param} />
		</React.Suspense>
	);
};
